import {Box, Stack, Typography} from '@mui/material';
import Symbol from 'assets/symbol.png';
import package_json from '../../../package.json';

export function Footer() {
	const copyright = 'ⓒ Attention Lab, Inc. All rights reserved.';
	const version = package_json.version;

	return (
		<Stack
			id="footer"
			zIndex={100}
			width="100%"
			direction="row"
			alignItems="center"
			justifyContent="space-between"
			padding="10px"
			borderTop="1px solid grey"
			bgcolor="background.default"
		>
			<Stack direction="row" alignItems="center" gap={1}>
				<Box component="img" src={Symbol} alt="Attention Lab" height="20px" padding="2px" bgcolor="black" sx={{filter: 'invert(1)', borderRadius: '50%'}} />
				<Typography variant="caption">v{version}</Typography>
			</Stack>

			<Typography variant="caption" color="white">
				{copyright}
			</Typography>
		</Stack>
	);
}
